var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42959 16.198C4.93653 15.0037 6.12012 14.166 7.49935 14.166H12.4993C13.8786 14.166 15.0622 15.0037 15.5691 16.198M13.3327 7.91602C13.3327 9.75696 11.8403 11.2493 9.99935 11.2493C8.1584 11.2493 6.66602 9.75696 6.66602 7.91602C6.66602 6.07507 8.1584 4.58268 9.99935 4.58268C11.8403 4.58268 13.3327 6.07507 13.3327 7.91602ZM18.3327 9.99935C18.3327 14.6017 14.6017 18.3327 9.99935 18.3327C5.39698 18.3327 1.66602 14.6017 1.66602 9.99935C1.66602 5.39698 5.39698 1.66602 9.99935 1.66602C14.6017 1.66602 18.3327 5.39698 18.3327 9.99935Z",
    stroke: "#0071F6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadIcon);
export default __webpack_public_path__ + "static/media/LeadIcon.a40c3d35aa4aa3c3b417baaa6188e99e.svg";
export { ForwardRef as ReactComponent };